module.exports = __webpack_public_path__ + "img/img_app_down_qr_code.bcc0e648.png";